"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M8.18,4.51V8.09H4.59V4.51H8.18M9.33,3.36H3.45V9.24H9.33V3.36Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M18,4.51V8.09H14.44V4.51H18m1.14-1.14H13.3V9.24h5.88V3.36Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M8.18,14.34v3.59H4.6V14.34H8.18M9.33,13.2H3.45v5.88H9.33V13.2Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#004864",
    x: "10.65",
    y: "3.35",
    width: "1.37",
    height: "5.27"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#004864",
    x: "8.45",
    y: "11.26",
    width: "10.75",
    height: "1.32"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#004864",
    x: "3.45",
    y: "11.26",
    width: "2.8",
    height: "1.32"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M13.17,14.55H11v1.32h1.58A5.36,5.36,0,0,1,13.17,14.55Z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M20.4,16.35h-.88a4,4,0,0,0-.24-.72L19.9,15a.15.15,0,0,0,0-.22L19,13.92a.15.15,0,0,0-.22,0l-.62.62a3.92,3.92,0,0,0-.72-.24v-.88a.15.15,0,0,0-.15-.15H16.4a.15.15,0,0,0-.15.15v.88a3.92,3.92,0,0,0-.72.24l-.62-.62a.15.15,0,0,0-.22,0l-.87.87a.15.15,0,0,0,0,.22l.62.62a4,4,0,0,0-.24.72h-.88a.15.15,0,0,0-.15.15v.92a.15.15,0,0,0,.15.15h.88a4,4,0,0,0,.24.72l-.63.62a.15.15,0,0,0,0,.22l.87.87a.16.16,0,0,0,.22,0l.62-.62a4,4,0,0,0,.72.24v.88a.15.15,0,0,0,.15.15h.92a.15.15,0,0,0,.15-.15v-.88a4,4,0,0,0,.72-.24l.63.62A.15.15,0,0,0,19,20l.87-.87a.15.15,0,0,0,0-.22l-.62-.62a4,4,0,0,0,.24-.72h.88a.15.15,0,0,0,.15-.15V16.5A.15.15,0,0,0,20.4,16.35Zm-3.53,1.84A1.23,1.23,0,1,1,18.09,17,1.23,1.23,0,0,1,16.86,18.19Z"
  }));
};

exports["default"] = _default;